export default {
  create() {
    return {
      endpoint: `/api/v1/test_mails`,
      method: "POST",
      options: {}
    };
  }
};
